<template>
  <div>
    <!-- 蒙层 -->
    <div class="overlay" v-if="dropdownVisible.cases" @click="handleDropdownVisible('cases', false)"></div>

    <el-row class="navbar" justify="space-between" align="middle"
      :class="{ 'navbar-fixed': true, 'navbar-scrolled': isScrolled, 'navbar-transparent': !isScrolled && isHomePage }">
      <el-col :span="4" class="logo">
        <router-link to="/">
          <!-- 根据滚动状态显示不同的logo -->
          <img v-if="!isScrolled" src="../assets/logo.png" alt="logo">
          <img v-else src="../assets/logo2.png" alt="logo">
        </router-link>
      </el-col>
      <el-col :span="15">
        <div class="nav-links">
          <!-- 产品中心 -->
          <el-dropdown ref="dropdownCenter" popper-class="full-width-dropdown"
            @visible-change="(val) => handleDropdownVisible('cases', val)">
            <span class="el-dropdown-link"  style="cursor: pointer;">
              产品中心
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <ProductCenterDropdown @close-dropdown="closeCenterDropdown" />
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <!-- 解决方案 -->
          <el-dropdown ref="dropdownCustomer" popper-class="full-width-dropdown"
            @visible-change="(val) => handleDropdownVisible('cases', val)">
            <span class="el-dropdown-link" style="cursor: pointer;">
              解决方案
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <CustomerCaseDropdown @close-dropdown="closeCustomerDropdown" />
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <!-- 客户案例 -->
          <el-dropdown disabled>
            <span class="el-dropdown-link">
              客户案例
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>Action 1</el-dropdown-item>
                <el-dropdown-item>Action 2</el-dropdown-item>
                <el-dropdown-item>Action 3</el-dropdown-item>
                <el-dropdown-item disabled>Action 4</el-dropdown-item>
                <el-dropdown-item divided>Action 5</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <!-- 文档中心 -->
          <el-dropdown disabled>
            <span class="el-dropdown-link">
              文档中心
              <!-- <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon> -->
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>Action 1</el-dropdown-item>
                <el-dropdown-item>Action 2</el-dropdown-item>
                <el-dropdown-item>Action 3</el-dropdown-item>
                <el-dropdown-item disabled>Action 4</el-dropdown-item>
                <el-dropdown-item divided>Action 5</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <!-- 产品定价 -->
          <el-dropdown disabled>
            <span class="el-dropdown-link" style="cursor: pointer;" @click="handlePricingClick">
              产品定价
              <!-- <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon> -->
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>Action 1</el-dropdown-item>
                <el-dropdown-item>Action 2</el-dropdown-item>
                <el-dropdown-item>Action 3</el-dropdown-item>
                <el-dropdown-item disabled>Action 4</el-dropdown-item>
                <el-dropdown-item divided>Action 5</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-col>
      <el-col :span="4" class="login-col">
        <button class="login-button" @click="handleLogin">
          <span class="login-text-full">登录/注册</span>
          <span class="login-text-mobile">登录</span>
        </button>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, toRef, watch } from 'vue';
import { ArrowDown } from "@element-plus/icons-vue";
import CustomerCaseDropdown from "./CustomerCaseDropdown/index.vue";
import ProductCenterDropdown from "./ProductCenterDropdown/ProductCenterDropdown.vue";
import { useRoute,useRouter } from 'vue-router';
import config from '@/config';

import useStore from '@/store';
const router = useRouter();

const store = useStore();

// 定义props，接收背景颜色
// const props = defineProps({
//   // 背景颜色，可以是颜色值或渐变
//   backgroundColor: {
//     type: String,
//     default: 'linear-gradient(to right, #230C28, #381740)'
//   },
//   // 是否使用渐变
//   useGradient: {
//     type: Boolean,
//     default: true
//   },
//   // 渐变开始颜色
//   startColor: {
//     type: String,
//     default: '#230C28'
//   },
//   // 渐变结束颜色
//   endColor: {
//     type: String,
//     default: '#381740'
//   }
// });

// 获取当前路由
const route = useRoute();
// 判断是否在首页
const isHomePage = computed(() => {
  return route.path === '/' || route.path === '/home' || route.path === '/swiperHome';
});

const currentSlideIndex = toRef(store.$state, 'currentSlideIndex');

// 滚动状态
const scrollY = ref(0);
// const isScrolled = ref(false); 

const isScrolled = computed(() => {
  return (scrollY.value > 80 || currentSlideIndex.value > 0)
})

// 动态添加/移除body类名
watch(isHomePage, (newVal) => {
  if (newVal) {
    document.body.classList.add('home-page');
  } else {
    document.body.classList.remove('home-page');
  }
}, { immediate: true });



// 计算导航栏样式
// const navbarStyle = computed(() => {
//   // 如果滚动了，显示白色背景
//   if (isScrolled.value) {
//     return {
//       background: 'rgba(255, 255, 255, 0.95)',
//       boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
//     };
//   } 
//   // 如果在首页且未滚动，使用传入的背景颜色
//   else if (isHomePage.value) {
//     return {
//       background: props.backgroundColor
//     };
//   }
//   // 其他页面且未滚动，使用默认渐变
//   else if (props.useGradient) {
//     return {
//       background: `linear-gradient(to right, ${props.startColor}, ${props.endColor})`
//     };
//   } 
//   // 其他情况
//   else {
//     return {
//       background: props.backgroundColor
//     };
//   }
// });

// 处理滚动事件
const handleScroll = () => {
  scrollY.value = window.scrollY;
  // isScrolled.value = ;
};

// 组件挂载时添加滚动监听
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  // 初始化滚动状态
  handleScroll();
});

// 组件卸载时移除滚动监听
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

const dropdownCustomer = ref(null);
const dropdownCenter = ref(null);
const dropdownVisible = reactive({
  products: false,
  solutions: false,
  cases: false,
  docs: false
});

const handleDropdownVisible = (key, value) => {
  // 重置所有下拉菜单状态
  Object.keys(dropdownVisible).forEach(k => {
    dropdownVisible[k] = k === key ? value : false;
  });
};

const closeCustomerDropdown = () => {
  const refCustomer = dropdownCustomer.value;
  refCustomer && refCustomer.handleClose();
};
const closeCenterDropdown = () => {
  const refCustomer = dropdownCenter.value;
  refCustomer && refCustomer.handleClose();
};

// 处理点击事件
const handlePricingClick = () => {
router.push(`/productPrice/index`);
};

// 处理登录按钮点击事件
const handleLogin = () => {
  // 从配置文件获取登录URL，并在新窗口打开
  window.open(config.loginUrl, '_blank');
};

</script>

<style lang="scss">
.navbar {
  height: 80px;
  /* 设置导航栏高度 */
  transition: all 0.3s ease;
  width: 100%;
  z-index: 1000;
  box-sizing: border-box;
  padding: 10px 0;
  /* 默认样式：非首页的紫色背景 */
  background-color: #230C28;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);

  .el-dropdown-link {
    color: #fff;
  }

  .login-button {
    background-color: #46384F;
    color: white;
  }

  &.navbar-fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
  }

  /* 首页未滚动时透明背景 */
  &.navbar-transparent {
    background-color: transparent !important;
    /* 使用!important确保覆盖其他样式 */
    box-shadow: none;

    .el-dropdown-link {
      color: #fff;
    }

    .login-button {
      background-color: #46384F;
      color: #fff;
    }
  }

  /* 滚动后的样式（所有页面） */
  &.navbar-scrolled {
    background-color: rgba(255, 255, 255, 0.95) !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .el-dropdown-link {
      color: #333;
    }

    .login-button {
      background-color: #0589FD;
      color: white;
    }
  }
}

.full-width-dropdown {
  width: 100% !important;
  left: 0 !important;
  border-radius: 0 !important;
  height: 380px;
  margin-top: 0 !important;
  inset: 80px auto auto 0px !important;
  z-index: 3000 !important;
  /* 确保下拉菜单在最上层 */
  position: fixed !important;
  /* 使用固定定位，跟随导航栏 */

  /* 确保边界无缝对接 */
  border-top: none !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;

  /* 确保箭头不会导致间隙 */
  .el-popper__arrow {
    border-bottom-color: white !important;
    border-right-color: white !important;

    &::before {
      background: white !important;
    }
  }

  .el-dropdown-menu {
    padding: 0;
    width: 100%;
    max-width: 1600px;  /* 从1200px增加到1400px，给右侧扩展留出空间 */
    margin: 0 auto;
    border-radius: 0;
  }
}

/* 覆盖Element Plus的弹出层样式 */
:deep(.el-dropdown__popper) {
  position: fixed !important;
  transform: none !important;
  margin: 0 !important;
  transition: none !important;
}

.logo {
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  padding-left: 200px;
  padding-right: 10px;
  box-sizing: border-box;

  img {
    width: 110px;
    height: auto;
    display: block;
    object-fit: contain;
  }
}

.nav-links {
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  margin-left: 30px; /* 与logo的间距 */
}

.el-dropdown-link {
  color: #fff;
  cursor: default;
  margin: 0 15px;
  outline: none;
  transition: color 0.3s ease;

  &:focus {
    outline: none;
  }
}

/* 登录按钮容器 - 确保靠右对齐 */
.login-col {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 348px;
  box-sizing: border-box;
}

.login-button {
  background-color: #46384F;
  /* 初始状态背景色 */
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  /* 添加过渡效果 */

  /* 默认显示完整文字，隐藏移动端文字 */
  .login-text-full {
    display: inline;
     white-space: nowrap;
  }

  .login-text-mobile {
    display: none;
  }
}

/* 客户案例下拉菜单样式 */
.case-dropdown {
  .el-dropdown-menu {
    padding: 20px 0;
    min-width: 800px;
    border-radius: 0;
    margin-top: 0;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  }
}

/* 响应式调整 */
@media screen and (max-width: 1600px) {
  .login-col {
    padding-right: 150px;
  }
}

@media screen and (max-width: 1200px) {
  .login-col {
    padding-right: 80px;
  }

  .case-container {
    .el-row {
      flex-wrap: wrap;
    }

    .el-col-6 {
      width: 50%;
      margin-bottom: 20px;
    }
  }
}

/* 移动端导航栏优化 */
@media screen and (max-width: 768px) {
  .navbar {
    padding: 8px 0;
    height: 70px;

    :deep(.el-col) {
      display: flex;
      align-items: center;
    }

    :deep(.el-col:nth-child(1)) {
      flex: 0 0 auto;
    }

    :deep(.el-col:nth-child(2)) {
      flex: 1 1 auto;
      min-width: 0;
      overflow: hidden;
    }

    :deep(.el-col:nth-child(3)) {
      flex: 0 0 auto;
    }
  }

  .logo {
    padding-left: 15px;
    flex-shrink: 0;
  }

  .login-col {
    padding-right: 15px;
    display: flex !important;
    justify-content: flex-end !important;
    align-items: center;
    flex-shrink: 0;
    margin-left: auto;
  }

    .logo img {
    max-width: 80px;
      width: 80px;
    }

    .nav-links {
    gap: 4px;
    margin-left: 20px; /* 与logo的间距 */
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;

      .el-dropdown-link {
      margin: 0 2px;
        font-size: 14px;
      padding: 8px 4px;
      min-width: 44px;
        text-align: center;
        border-radius: 4px;
      white-space: nowrap;
      flex-shrink: 0;
    }
    }

    .login-button {
      padding: 8px 15px;
      font-size: 13px;
      min-width: 70px;

      /* 移动端隐藏完整文字，显示简化文字 */
      .login-text-full {
        display: none;
      }

      .login-text-mobile {
        display: inline;
    }
  }

  .full-width-dropdown {
    height: 300px;
    top: 70px !important;
  }

  .overlay {
    top: 70px;
    height: calc(100vh - 70px);
  }
}

/* 超小屏幕 (320px - 479px) - 简化文字策略 */
@media screen and (max-width: 479px) {
  .navbar {
    padding: 8px 0;
    height: 65px;

    :deep(.el-col) {
      display: flex;
      align-items: center;
    }

    :deep(.el-col:nth-child(1)) {
      flex: 0 0 auto;
    }

    :deep(.el-col:nth-child(2)) {
      flex: 1 1 auto;
      min-width: 0;
      overflow: hidden;
    }

    :deep(.el-col:nth-child(3)) {
      flex: 0 0 auto;
    }
  }

  .logo {
    padding-left: 10px;
    flex-shrink: 0;
  }

  .login-col {
    padding-right: 10px;
    display: flex !important;
    justify-content: flex-end !important;
    align-items: center;
    flex-shrink: 0;
    margin-left: auto;
  }

    .logo img {
    max-width: 65px;
      width: 65px;
    }

    .nav-links {
    gap: 0;
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    margin-left: 15px; /* 与logo的间距 */

      .el-dropdown {
      flex-shrink: 0;

        .el-dropdown-link {
        margin: 0 1px;
          font-size: 0; /* 隐藏原始文字 */
        padding: 8px 2px;
        min-width: 36px;
          line-height: 1.2;
          text-align: center;
          border-radius: 4px;
          white-space: nowrap;
        flex-shrink: 0;
        overflow: visible;
        position: relative;

          &::before {
            font-size: 12px; /* 显示简化文字 */
            font-weight: 500;
            color: inherit;
          display: inline-block;
          white-space: nowrap;
          width: auto;
          }

          /* 保持图标显示 */
          .el-icon {
          font-size: 10px;
          margin-left: 2px;
          }

          /* 悬停效果 */
          &:hover {
            background-color: rgba(64, 158, 255, 0.1);
            border-radius: 4px;
            transition: all 0.2s ease;
          }
        }
      }

      /* 为不同导航项显示简化文字 */
      .el-dropdown:nth-child(1) .el-dropdown-link::before {
        content: "产品";
      }

      .el-dropdown:nth-child(2) .el-dropdown-link::before {
        content: "方案";
      }

      .el-dropdown:nth-child(3) .el-dropdown-link::before {
        content: "案例";
      }

      .el-dropdown:nth-child(4) .el-dropdown-link::before {
        content: "文档";
      }

    .el-dropdown:nth-child(5) .el-dropdown-link {
      min-width: 42px; /* 为"定价"两个字留出足够空间 */
      padding: 8px 3px;
    }

      .el-dropdown:nth-child(5) .el-dropdown-link::before {
        content: "定价";
      }
    }

    .login-button {
      padding: 4px 6px;
      font-size: 9px;
      min-width: 35px;
      height: 24px;
      border-radius: 3px;
      font-weight: 500;
  }

  .full-width-dropdown {
    height: 280px;
    top: 65px !important;
  }

  .overlay {
    top: 65px;
    height: calc(100vh - 65px);
  }
}

.case-container {
  padding: 20px;
}

.case-section {
  padding: 0 15px;
  text-align: left;
  height: 100%;

  &:last-child {
    border-right: none;
  }

  .section-top {
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: 600;
    color: #677489;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }
}

/* 左侧图片区域样式 */
.case-image {
  position: relative;
  height: 100%;
  padding-right: 15px;

  img {
    width: 100%;
    height: 180px;
    object-fit: cover;
    border-radius: 4px;
  }
}

.image-desc {
  margin-top: 15px;

  h3 {
    color: #677489;
    font-size: 16px;
    margin-bottom: 8px;
  }

  p {
    color: #666;
    font-size: 12px;
    line-height: 1.5;
  }
}

.section-desc {
  color: #666;
  font-size: 12px;
  margin-bottom: 20px;
}

.case-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  cursor: pointer;
}

.case-icon {
  margin-right: 10px;
  color: #3366cc;
}

.case-content {
  h4 {
    color: #333;
    font-size: 16px;
    margin: 0 0 5px 0;
    white-space: nowrap;
  }

  p {
    color: #666;
    font-size: 12px;
    margin: 0;
  }
}

/* 蒙层样式 */
.overlay {
  position: fixed;
  top: 80px;
  /* 与导航栏高度一致 */
  left: 0;
  width: 100%;
  height: calc(100vh - 80px);
  background-color: rgba(0, 0, 0, 0.5);
  /* 半透明黑色背景 */
  z-index: 2000;
  /* 确保在下拉菜单之下，但在其他内容之上 */
  transition: opacity 0.3s ease;
}

.el-popper.el-dropdown__popper {
  margin-top: 0 !important;
  z-index: 3000 !important;
  /* 确保弹出层在最上面 */
}

/* 移动端样式 - 只在移动端去除下拉菜单的max-width限制 */
@media (max-width: 768px) {
  .full-width-dropdown .el-dropdown-menu {
    max-width: none !important;
  }
}
</style>
